module.exports = __webpack_public_path__ + "img/pageinteriors_03auditoria-en-seguros-01.2a503cb6.jpg";